exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.detailtit {\n    background: #f6f6f6;\n    height: 60px;\n    line-height: 60px;\n    padding: 0 15px;\n    font-size: 12px;\n    border: 1px solid #e1e1e1;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    width: 100%;\n    margin-bottom: 20px;\n}\n.detailtit i {\n    font-style: normal;\n}\n.el-table th{\n    background:#F5F5F5 !important;\n    font-size:15px;\n}\n.set-row{\n    margin-bottom:15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60f2587c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/berichten/berichten_survey.vue
// module id = mKae
// module chunks = 9